import { render, staticRenderFns } from "./RecordExportModal.vue?vue&type=template&id=a5f64d52&scoped=true"
import script from "./RecordExportModal.vue?vue&type=script&lang=js"
export * from "./RecordExportModal.vue?vue&type=script&lang=js"
import style0 from "./RecordExportModal.vue?vue&type=style&index=0&id=a5f64d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f64d52",
  null
  
)

export default component.exports